"use client";

import { Loader } from "@/components/ai-elements/loader";
import { AnimatedStatus } from "@/components/ui/animated-status";
import { getStatusMessage, getToolMessage } from "@/lib/agent-utils";
import { getToolIcon } from "@/lib/tool-config";
import type { AgentStatus } from "@/types/agents";

interface ChatStatusIndicatorsProps {
  agentStatus: AgentStatus | null;
  currentToolCall: string | null;
  status?: string;
}

export function ChatStatusIndicators({
  agentStatus,
  currentToolCall,
  status,
}: ChatStatusIndicatorsProps) {
  const statusMessage = getStatusMessage(agentStatus);
  const toolMessage = getToolMessage(currentToolCall);

  // Always prioritize tool message over agent status when a tool is running
  const displayMessage = toolMessage || statusMessage;

  // Get icon for current tool - always show icon when tool is running
  const toolIcon = currentToolCall ? getToolIcon(currentToolCall) : null;

  return (
    <div className="h-8 flex items-center">
      <AnimatedStatus
        text={displayMessage}
        shimmerDuration={0.75}
        fadeDuration={0.1}
        variant="slide"
        className="text-xs font-bold text-[var(--mindup-plum)]/70 dark:text-[var(--mindup-pink)]/70"
        icon={toolIcon}
      />

      {((agentStatus && !getStatusMessage(agentStatus)) ||
        (status === "submitted" && !agentStatus && !currentToolCall)) && (
        <Loader />
      )}
    </div>
  );
}
